window.customElements.define(
    "truncated-table",
    class extends HTMLElement {
        private table: HTMLTableElement | null;
        private showHiddenItemsButton: HTMLButtonElement | null;

        constructor() {
            super();

            this.table = this.querySelector("table");
            this.showHiddenItemsButton = this.querySelector("[data-truncated-table-show-hidden]");
        }

        connectedCallback() {
            this.showHiddenItemsButton?.addEventListener(
                "click",
                (event) => {
                    this.table?.querySelectorAll("[hidden]")
                        .forEach((el) => el.removeAttribute("hidden"));
                    this.querySelectorAll("[data-truncated-table-hide-on-show]")
                        .forEach((el) => el.setAttribute("hidden", "hidden"));
                }
            )
        }
    },
);
